import {
    Breadcrumb,
    BreadcrumbList,
    BreadcrumbItem,
    BreadcrumbLink,
    BreadcrumbSeparator,
    BreadcrumbPage,
} from "./ui/breadcrumb";
import { SidebarTrigger, useSidebar } from "./ui/sidebar";
import { Link, useLocation } from "react-router-dom";
import NotificationBell from "./dropdown-menu/NotificationBell";
import { NavUser } from "./nav-user";
import { MessageCirclePlus, Search } from "lucide-react";
import { Button } from "./ui/button";
import { useSearchShortcut } from "@/hooks/useKeyboardShortcut";
import { useNavigationStore } from "@/stores/navigation-store";
import useIsAdminPanel from "@/hooks/useIsAdminPanel";

export function AppHeader() {
    const location = useLocation();
    const pathname = location.pathname;
    const { open } = useSidebar();
    const { setSearchIsOpen } = useNavigationStore();
    const isAdminPanel = useIsAdminPanel();
    useSearchShortcut(() => setSearchIsOpen(true));

    function getBreadcrumbs(pathname: string) {
        const paths = pathname.split("/").filter(Boolean);
        const breadcrumbs: any[] = [];

        let currentPath = "";
        for (const segment of paths) {
            currentPath += `/${segment}`;
            breadcrumbs.push({
                label: segment.charAt(0).toUpperCase() + segment.slice(1),
                href: segment === "chats" ? "/" : currentPath,
            });
        }

        return breadcrumbs;
    }

    const breadcrumbs = getBreadcrumbs(pathname);

    return (
        <header className="sticky left-0 right-0 top-0 z-10 flex h-16 shrink-0 items-center justify-between gap-2 bg-background px-4 transition-[width,height] ease-linear group-has-[[data-collapsible=icon]]/sidebar-wrapper:h-12">
            <div className="flex items-center gap-2">
                <SidebarTrigger />
                {!isAdminPanel && !open && (
                    <div className="flex items-center gap-2">
                        <Button className="h-7 w-7" variant="ghost" size="icon" aria-label="Search">
                            <Search className="!h-5 !w-5" />
                        </Button>
                        <Link to="/">
                            <Button className="h-7 w-7" variant="ghost" size="icon" aria-label="New Chat">
                                <MessageCirclePlus className="!h-5 !w-5" />
                            </Button>
                        </Link>
                    </div>
                )}
                <Breadcrumb>
                    <BreadcrumbList>
                        {breadcrumbs.map((crumb, index) => (
                            <div key={crumb.href} className="flex flex-row items-center gap-3">
                                <BreadcrumbItem>
                                    {index < breadcrumbs.length - 1 ? (
                                        <BreadcrumbLink asChild>
                                            <Link to={crumb.href} className="text-link">
                                                {crumb.label}
                                            </Link>
                                        </BreadcrumbLink>
                                    ) : (
                                        <BreadcrumbPage className="truncate max-w-24 md:max-w-60 lg:max-w-max">{crumb.label}</BreadcrumbPage>
                                    )}
                                </BreadcrumbItem>
                                {index < breadcrumbs.length - 1 && <BreadcrumbSeparator />}
                            </div>
                        ))}
                    </BreadcrumbList>
                </Breadcrumb>
            </div>
            <div className="flex gap-2">
                <span className="flex-grow">
                    <NotificationBell />
                </span>
                <span className="flex-grow">
                    <NavUser />
                </span>
            </div>
        </header>
    );
}
